// extracted by mini-css-extract-plugin
export default {"Main":"LandingPage_Main__CElQU","button":"LandingPage_button__DB4TA","loading":"LandingPage_loading__6RuZk"};